import React, {PureComponent, ReactNode} from "react"
import styled from "styled-components"

import Banner from "@irati/ui/src/Banner"

const BannerWrapper = styled.div`
  margin-bottom: 15px;
`

interface Props {
  bannerImg?: string
  bannerChild?: ReactNode
}

class RecognitionLayout extends PureComponent<Props> {
  static defaultProps = {
    bannerImg: undefined,
    bannerChild: undefined
  }

  render() {
    const {bannerImg, bannerChild, children} = this.props

    return (
      <>
        {bannerImg && (
          <BannerWrapper>
            <Banner backgroundColor="transparent" bannerImg={bannerImg}>
              {bannerChild}
            </Banner>
          </BannerWrapper>
        )}
        {children}
      </>
    )
  }
}

export default RecognitionLayout
